import axios from "axios";

const csrfToken = document.querySelector("[name='csrf-token']")?.content || "";

const api = axios.create({
  headers: {
    Accept: "application/json",
    "Content-type": "application/json",
    "X-CSRF-Token": csrfToken
  },
});

export default api;
